<script lang="ts" setup>
// Prev/Next over a paged list. The caller supplies the label and says whether either direction exists,
// because a keyset-paged list has no page numbers: a page starts after the last id of the page before it.
// The run history list has page numbers and the attempt pager walks numbered sends; both use it too, so the
// three pagers look the same.
defineProps<{
  label: string;
  canPrev: boolean;
  canNext: boolean;
  fetching?: boolean;
}>();
defineEmits<{ prev: []; next: [] }>();
</script>

<template>
  <div class="d-flex align-items-center justify-content-between px-3 py-2 border-top">
    <button
      type="button"
      class="btn btn-sm btn-outline-secondary"
      aria-label="Previous"
      :disabled="!canPrev || fetching"
      @click="$emit('prev')"
    >
      <i class="bi bi-chevron-left"></i>
      <span class="d-none d-md-inline ms-1">Prev</span>
    </button>
    <small class="text-muted">
      {{ label }}
      <i v-if="fetching" class="bi bi-arrow-repeat spin ms-1" aria-hidden="true"></i>
    </small>
    <button
      type="button"
      class="btn btn-sm btn-outline-secondary"
      aria-label="Next"
      :disabled="!canNext || fetching"
      @click="$emit('next')"
    >
      <span class="d-none d-md-inline me-1">Next</span>
      <i class="bi bi-chevron-right"></i>
    </button>
  </div>
</template>
